<div class="form-horizontal">

  <div class="form-group row">
    <div class="btn-group col-4">
      <button type="button" class="btn btn-outline-primary" (click)="draft()"> <i
          class="fa fa-plus"></i>&nbsp;Borradores</button>
      <button type="button" class="btn btn-outline-success" *ngIf="canShowSaveButton()" (click)="save()"><i
          class="fa fa-floppy-o"></i>&nbsp;Crear Solicitud </button>
    </div>
  </div>
  <div class="alert alert-info" role="alert" *ngIf="!canShowSaveButton() || this.requestType === 'AVAL'">
    <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Validación Biométrica
    </h4>
    <p>Es necesario realizar un proceso de <b>validación biométrica</b> antes de crear una solicitud. Primero completa
      la informacion de la solicitud, guarda en borradores y luego procede con la validación.</p>
    <hr>
    <div class="mb-0 d-flex justify-content-end">
      <button type="button" class="ml-2 btn btn-outline-info" (click)="handleGoToBiometryValidationClick()">Ir a
        Validación Biométrica</button>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-12">

      <tabset type="fill">
        <tab *ngIf="formsToShowConfig.generalnformationForm" [customClass]="getClassFromForm('generalnformationForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-list-alt"></i> Información General</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.generalnformationForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en la Información General</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('generalnformationForm')">Ir a Completar Campos</button>
            </div>
          </div>
          <pos-general-information-step [generalnformationForm]="getFormAsFormGroup('generalnformationForm')"
            [readonly]="true">
          </pos-general-information-step>
        </tab>
        <tab *ngIf="formsToShowConfig.bankRepresentativeForm"
          [customClass]="getClassFromForm('bankRepresentativeForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-users"></i> Enlace de Aval</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.bankRepresentativeForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en el Enlace de Aval</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('bankRepresentativeForm')">Ir a Completar Campos</button>
            </div>
          </div>
          <app-bank-representative-step [bankRepresentativeForm]="getFormAsFormGroup('bankRepresentativeForm')"
            [disabled]="true" [isEdit]="true"></app-bank-representative-step>
        </tab>
        <tab *ngIf="formsToShowConfig.companyInformationForm"
          [customClass]="getClassFromForm('companyInformationForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-user"></i> Datos de Empresa</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.companyInformationForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en los Datos de Empresa</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('companyInformationForm')">Ir a Completar Campos</button>
            </div>
          </div>
          <pos-company-information-step [companyInformationForm]="getFormAsFormGroup('companyInformationForm')"
            [onbaseCatalogue]="onbaseCatalogue" [readonly]="true"></pos-company-information-step>
        </tab>
        <tab *ngIf="formsToShowConfig.companyAddressInformationForm"
          [customClass]="getClassFromForm('companyAddressInformationForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-map-marker"></i> Información de Ubicacion Empresa</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.companyAddressInformationForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en la Información de Ubicacion Empresa</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('companyAddressInformationForm')">Ir a Completar Campos</button>
            </div>
          </div>
          <pos-company-address-information-step
            [companyAddressInformationForm]="getFormAsFormGroup('companyAddressInformationForm')"
            [onbaseCatalogue]="onbaseCatalogue" [isEdit]="true"
            [readonly]="true"></pos-company-address-information-step>
        </tab>
        <tab *ngIf="formsToShowConfig.companyContactInformationForm"
          [customClass]="getClassFromForm('companyContactInformationForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-users"></i> Información de Contacto / Encargado de pago</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.companyContactInformationForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en la Información de Contacto / Encargado de pago</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('companyContactInformationForm')">Ir a Completar Campos</button>
            </div>
          </div>
          <pos-company-contact-information-step
            [companyContactInformationForm]="getFormAsFormArray('companyContactInformationForm')" [disabled]="disable"
            [isEdit]="true"></pos-company-contact-information-step>
        </tab>
        <tab *ngIf="formsToShowConfig.companyBankingReferenceForm"
          [customClass]="getClassFromForm('companyBankingReferenceForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-users"></i> Información de Referencias Bancarias / Comerciales</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.companyBankingReferenceForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en la Información de Referencias Bancarias / Comerciales</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('companyBankingReferenceForm')">Ir a Completar Campos</button>
            </div>
          </div>
          <pos-company-bank-references-step
            [companyBankingReferenceForm]="getFormAsFormArray('companyBankingReferenceForm')" [disabled]="disable"
            [isEdit]="true"></pos-company-bank-references-step>
        </tab>
        <tab *ngIf="formsToShowConfig.personInformationForm" [customClass]="getClassFromForm('personInformationForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-user"></i> Datos Personales</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.personInformationForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en los Datos Personales</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('personInformationForm')">Ir a Completar Campos</button>
            </div>
          </div>
          <app-person-information-step [personInformationForm]="getFormAsFormGroup('personInformationForm')"
            [readonly]="true" [isShortFormActiveForPlan]="isShortFormActiveForPlan">
          </app-person-information-step>
        </tab>
        <tab *ngIf="formsToShowConfig.personAddressInformationForm"
          [customClass]="getClassFromForm('personAddressInformationForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-map-marker"></i> Información de Domicilio</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.personAddressInformationForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en la Información de Domicilio</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('personAddressInformationForm')">Ir a Completar Campos</button>
            </div>
          </div>
          <app-person-address-information-step [onbaseCatalogue]="onbaseCatalogue"
            [personAddressInformationForm]="getFormAsFormGroup('personAddressInformationForm')"
            [hideStreeFields]="hideStreet" [isEdit]="true" [readonly]="true"
            [isShortFormActiveForPlan]="isShortFormActiveForPlan">
          </app-person-address-information-step>
        </tab>
        <tab *ngIf="formsToShowConfig.personIncomeInformationForm"
          [customClass]="getClassFromForm('personIncomeInformationForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-money-bill"></i> Información de Trabajo</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.personIncomeInformationForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en la Información de Trabajo</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('personIncomeInformationForm')">Ir a Completar Campos</button>
            </div>
          </div>
          formulario corto activo? {{isShortFormActiveForPlan}}
          <app-person-income-information-step [onbaseCatalogue]="onbaseCatalogue"
            [personIncomeInformationForm]="getFormAsFormGroup('personIncomeInformationForm')" [customer]="customer"
            [hideStreet]="hideStreet" [isEdit]="true" [customerType]="customerType" [readonly]="true"
            [isShortFormActiveForPlan]="isShortFormActiveForPlan">
          </app-person-income-information-step>
        </tab>
        <tab *ngIf="formsToShowConfig.personReferencesInformationform"
          [customClass]="getClassFromForm('personReferencesInformationform')">
          <ng-template tabHeading>
            <span><i class="fa fa-users"></i> Información de Referencia</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.personReferencesInformationform">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en la Información de Referencia</h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger"
                (click)="goToCompleteStep('personReferencesInformationform')">Ir a Completar Campos</button>
            </div>
          </div>
          <app-person-references-information-step
            [personReferencesInformationform]="getFormAsFormArray('personReferencesInformationform')"
            [disabled]="disable" [isShortFormActiveForPlan]="isShortFormActiveForPlan">
          </app-person-references-information-step>
        </tab>
        <tab *ngIf="formsToShowConfig.observationForm" [customClass]="getClassFromForm('observationForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-pencil"></i> Observaciones</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.observationForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en las Observaciones </h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger" (click)="goToCompleteStep('observationForm')">Ir
                a Completar Campos</button>
            </div>
          </div>
          <pos-observations-step [observationForm]="getFormAsFormGroup('observationForm')"
            [readonly]="true"></pos-observations-step>
        </tab>
        <tab *ngIf="formsToShowConfig.documentsForm" [customClass]="getClassFromForm('documentsForm')">
          <ng-template tabHeading>
            <span><i class="fa fa-folder-open"></i> Documentos</span>
          </ng-template>
          <div class="alert alert-danger" role="alert" [hidden]="formsValid.documentsForm">
            <h4 class="alert-heading"><i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>Hace falta
              campos por llenar en los Documentos </h4>
            <p>Esta pantalla es solo de vista previa, utilizar el boton de <b>Ir a Completar Campos</b></p>
            <hr>
            <div class="mb-0 d-flex justify-content-end">
              <button type="button" class="ml-2 btn btn-outline-danger" (click)="goToCompleteStep('documentsForm')">Ir a
                Completar Campos</button>
            </div>
          </div>
          <pos-documents-step [documentsForm]="getFormAsFormArray('documentsForm')" [disabled]="disable">
          </pos-documents-step>

        </tab>
      </tabset>
    </div>
  </div>
</div>